// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT license.
import { Contracts } from "./Contracts";
import { VoiceProfileResult } from "./Exports";
/**
 * Output format
 * @class VoiceProfileAuthorizationPhraseResult
 */
export class VoiceProfileAuthorizationPhraseResult extends VoiceProfileResult {
    constructor(reason, statusText, json) {
        super(reason, statusText);
        this.privPhrases = [];
        Contracts.throwIfNullOrUndefined(json, "phrases array");
        for (const item of json) {
            this.privPhrases.push(item.passPhrase);
        }
    }
    get phrases() {
        return this.privPhrases;
    }
}

//# sourceMappingURL=VoiceProfileAuthorizationPhraseResult.js.map
